export default __webpack_public_path__ + "static/media/dolby.02a40be4.jpg";